export default "__VITE_ASSET__BKmkZbE3__"